import {useState, useEffect, useCallback, useRef} from 'react';
import ZimssaConstant from 'commons/ZimssaConstant';
import { apiVerifySet, apiVerifyCheck, } from 'api/ZimssaAPI';
import { ALERT_VERIFY_SUCCESS } from 'commons/ZimssaString';
import { TResponseResult, TVerifyType } from 'api/ApiTypes';

const useAuthVerify = () => {
    const [isSend, setIsSend] = useState<boolean>(false);
    const [isReSend, setIsReSend] = useState<boolean>(false);
    const [isVerify, setIsVerify] = useState<boolean>(false);
    const [timer, setTimer] = useState<number>(0);

    let interval = useRef(0);

    // 문자 전송
    useEffect(() => {
        if (timer === ZimssaConstant.AUTH_RESEND_TIME) {
            setIsReSend(true)
        }
        if (isSend && timer !== 0) {
            interval.current = window.setInterval(() => {
                setTimer(timer - 1);
            }, 1000);
            return () => {
                window.clearInterval(interval.current);
            };
        }
        if(isVerify) {
            window.clearTimeout(interval.current);
        }
    }, [isSend, timer, isVerify]);

    const sendSMSCallback = useCallback((phone: string, type: TVerifyType) => {
        apiVerifySet(phone, type).then((response) => {
            const { result, message } = response;
            if (result === 'success') {
                setIsSend(true);
                setTimer(ZimssaConstant.AUTH_EXPIRE_TIME);

                if (isSend && isReSend) {
                    setIsReSend(false);
                    setIsVerify(false);
                }
            } else {
                message && alert(message)
            }
        });
    }, [isReSend, isSend])

    // 인증 하기
    const authVerifyCallback = useCallback(
        (phone: string, authCode: string, type: TVerifyType): Promise<TResponseResult> => {
            return new Promise((resolve, reject) => {
                apiVerifyCheck(phone, authCode, type).then((response) => {
                    const { result, message } = response;

                    if (result === 'success') {
                        setIsVerify(true);
                        setTimer(0);
                        alert(ALERT_VERIFY_SUCCESS);

                    } else {
                        if (message) alert(message)
                    }
                }).catch(error => {
                    return reject(new Error(error));
                });
            })
        },
        []
    );

    const changeIsVerify = useCallback(() => {
        setIsVerify(!isVerify);
    }, [isVerify])

    return {
        timer,
        isSend,
        isReSend,
        isVerify,
        sendSMSCallback,
        authVerifyCallback,
        changeIsVerify
    }
};

export default useAuthVerify;